module.exports = __webpack_public_path__ + "staticesp/media/translate.d8843e92.svg";